import React,{Component} from 'react';
import bossBtn from './images/boss-btn.png';
import driverBtn from './images/driver-btn.png';
import goodsOwnerBtn from './images/goodsOwner-btn.png';
import xiaBtn from './images/xia-btn.png';
import bossBtnGreen from './images/boss-btn-green.png';
import driverBtnGreen from './images/driver-btn-green.png';
import goodsOwnerBtnGreen from './images/goodsOwner-btn-green.png';
import xiaBtnGreen from './images/xia-btn-green.png';
import goodsOwnerCode from './images/goodsOwnerCode.png';
import bossCode from './images/bossCode.png';
import driverCode from './images/driverCode.png';
import xiaCode from './images/xiaCode.png';
import qq from './images/qq.png';
import tel from './images/tel.png';

import email from './images/email.png';
import WeChat from './images/WeChat.png';

export class Footer extends Component{
    state = {
        bossBtn:bossBtn,
        driverBtn:driverBtn,
        goodsOwnerBtn:goodsOwnerBtn,
        xiaBtn:xiaBtn

    }

    handleShow = (e)=>{
        var id = e.target.id;

        if (id === 'bossBtn'){
            this.refs.bossBtn.style.display='block';
            this.setState({ bossBtn:bossBtnGreen});
        }else if (id === 'goodsOwnerBtn'){
            this.refs.goodsOwnerBtn.style.display='block';
            this.setState({ goodsOwnerBtn:goodsOwnerBtnGreen});
        }
        else if (id === 'driverBtn'){
            this.refs.driverBtn.style.display='block';
            this.setState({ driverBtn:driverBtnGreen});
        }
        else if (id === 'xiaBtn'){
            this.refs.xiaBtn.style.display='block';
            this.setState({ xiaBtn:xiaBtnGreen});
        }

    }


    handleHide = (e)=>{
        var id = e.target.id;

        if (id === 'bossBtn'){
            this.refs.bossBtn.style.display='none';
            this.setState({ bossBtn:bossBtn});
        }else if (id === 'goodsOwnerBtn'){
            this.refs.goodsOwnerBtn.style.display='none';
            this.setState({ goodsOwnerBtn:goodsOwnerBtn});
        }
        else if (id === 'driverBtn'){
            this.refs.driverBtn.style.display='none';
            this.setState({ driverBtn:driverBtn});
        }
        else if (id === 'xiaBtn'){
            this.refs.xiaBtn.style.display='none';
            this.setState({ xiaBtn:xiaBtn});
        }
    }

    render(){
             return (<div className='footer'>
                <div className='footer-top'>
                <div className='max-width-box'>
                    <div className='top-left'>
                        <dl className='footer-item-title'>
                            <dt>
                                客服咨询
                            </dt>

                        </dl>
                        <dl>
                            <dt>
                                <img src={tel} alt='电话联系方式' width='35' height='35' />
                            </dt>
                            <dd>
                                <p>020-8200-0284</p>
                                <p>020-8251-1531</p>
                            </dd>
                        </dl>
                        <dl style={{marginTop:28}}>
                            <dt>
                                <img src={qq} alt='qq联系方式' width='35' height='35' />
                            </dt>
                            <dd>
                                <p>3308-2009-45</p>
                                <p>3132-1459-90</p>
                            </dd>
                        </dl>
                        <dl style={{marginTop:28}}>
                            <dt>
                                <img src={email} alt='邮件联系方式' width='35' height='35' />
                            </dt>
                            <dd>
                                <p>zhaoxiuqing@56xyl.com</p>
                                <p>liaoshuang@56xyl.com</p>
                            </dd>
                        </dl>
                    </div>
                    <div className='top-center'>
                        <dl className='footer-item-title'>
                            <dt>
                                热门产品
                            </dt>
                        </dl>
                        <dl>

                            <dd className='bossBtn'>
                                <img id='bossBtn' src={this.state.bossBtn} alt='老板APP'
                                    onMouseOver={this.handleShow} onMouseOut={this.handleHide} />
                                <div className='code-box' ref ='bossBtn'>
                                    <div><img src={bossCode} alt='老板APP' /></div>
                                </div>
                            </dd>
                            <dd className='xiaBtn'>
                                <img id='xiaBtn' src={this.state.xiaBtn} alt='夏老师APP'
                                onMouseOver={this.handleShow} onMouseOut={this.handleHide} />
                                <div className='code-box' ref ='xiaBtn'>
                                    <div><img src={xiaCode} alt='夏老师APP' /></div>
                                </div>
                            </dd>
                            <dd className='driverBtn'>
                                <img id='driverBtn' src={this.state.driverBtn} alt='司机APP'
                                    onMouseOver={this.handleShow} onMouseOut={this.handleHide} />
                                <div className='code-box' ref ='driverBtn'>
                                    <div><img src={driverCode} alt='司机APP' /></div>
                                </div>
                            </dd>
                            <dd className='goodsOwnerBtn'>
                                <img id='goodsOwnerBtn' src={this.state.goodsOwnerBtn} alt='货主APP'
                                    onMouseOver={this.handleShow} onMouseOut={this.handleHide} />
                                <div className='code-box' ref ='goodsOwnerBtn'>
                                    <div><img src={goodsOwnerCode} alt='货主APP' /></div>
                                </div>
                            </dd>
                        </dl>
                    </div>
                    <div className='top-right'>
                         <p><img src={WeChat} alt='关注公众号' /></p>
                         <p>关注公众号</p>
                    </div>
                </div>
             </div>
            <div className='copyright'>
                <div className='max-width-box'>
                    <p>
                    Copyright © 2015 版权所有&nbsp;&nbsp;&nbsp;&nbsp;广州新集运开发有限公司  &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="https://beian.miit.gov.cn/" target="_blank"  rel="noopener noreferrer">粤ICP备15054320号</a>
                    </p>
                </div>
            </div>
        </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/footer/index.js